'use strict';

import {reverseUrl} from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var JcwBuppStateDiagram = new StateDiagram()
	.add('leader assigned', Q('team:leader_assigned'))
	.add('complainant contacted', Q.A(
		'team:leader_assigned',
		Q('contacts:call_completed', 'contacts:call_skipped')
	))
	.add('awaiting questionnaire', Q.A(
		'team:leader_assigned',
		Q('questionnaire_sent', 'questionnaire_send_skipped')
	))
	.add('questionnaire received', Q.A(
		'team:leader_assigned',
		Q('questionnaire_received', 'questionnaire_send_skipped', 'questionnaire_skipped'))
	)
	.add('ineligible', Q('ineligible'))
	.add('scheduling visit', Q('eligible'))
	.add('site visit scheduled', Q('site_visit_scheduled'))
	.add('site visited', Q('geo:site_visited', 'geo:site_visit_skipped'))
	.add('unqualified', Q('unqualified'))
	.add('scheduling inspection', Q('qualified'))
	.add('inspection scheduled', Q('final_inspection_scheduled'))
	.add('inspected', Q('geo:inspected', 'geo:final_inspection_skipped'))
	.add('completed', Q('release_form_signed', 'release_form_not_signed'))


export default function(incident) {
	JcwBuppStateDiagram.updateIncident(incident);
	if (incident.tags) {
		// This fixes a bug due to how we handle the next appointment.
		incident.tags.sort(function(a, b) {
			return new Date(a.created_time) > new Date(b.created_time) ? 1 : -1;
		});
		let tagData = {};
		for (let tag of incident.tags) {
			tagData[tag.content_type] = tag;
		}
		incident.tagData = tagData;
	}
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});

	// Update calendar iframe when there are changes to the appointments
	try {
		var lastAppointment = incident.tagData['entities.jcwbuppappointment'];
	} catch(e) {
		var lastAppointment = null;
	}
	if (lastAppointment) {
		let lastAppointmentUpdate = new Date(lastAppointment.updated_time);
		if ((new Date()).getTime() - lastAppointmentUpdate.getTime() < 30000) {
			let iframe = document.getElementById('google-calendar');
			if (iframe) {
				iframe.src = iframe.src;
				console.log('Refreshed iframe');
			}
		}
	}
}
